module.exports = __webpack_public_path__ + "img/GMTC-new.8af05aba.jpg";